import VSpacingContainer from 'bloko/blocks/vSpacing/VSpacingContainer';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import { GbbGoodFeature } from 'src/components/Price/Gbb';
import translation from 'src/components/translation';

const TrlKeys = {
    photos: 'price.tariffFeature.branding.photos',
    logo: 'price.tariffFeature.branding.logo',
    unlimitedTemplate: 'price.tariffFeature.branding.unlimitedTemplate',
    unlimitedBrandedVacancy: 'price.tariffFeature.branding.unlimitedBrandedVacancy',
    cleanPage: 'price.tariffFeature.branding.cleanPage',
};

const BrandingFeatures: TranslatedComponent = ({ trls }) => {
    return (
        <VSpacingContainer base={4}>
            <GbbGoodFeature>{trls[TrlKeys.photos]}</GbbGoodFeature>
            <GbbGoodFeature>{trls[TrlKeys.logo]}</GbbGoodFeature>
            <GbbGoodFeature>{trls[TrlKeys.unlimitedTemplate]}</GbbGoodFeature>
            <GbbGoodFeature>{trls[TrlKeys.unlimitedBrandedVacancy]}</GbbGoodFeature>
            <GbbGoodFeature>{trls[TrlKeys.cleanPage]}</GbbGoodFeature>
        </VSpacingContainer>
    );
};

export default translation(BrandingFeatures);
